import { createFileRoute } from "@tanstack/react-router";
import { McpConnections } from "@/components/mcp/mcp-connections";

export const Route = createFileRoute("/_app/organization/mcp")({
  component: McpConnections,
  head: () => ({ meta: [{ title: "Papier - AI connections" }] }),
});
